import { GridOptions } from 'ag-grid-community';
import React, { ComponentType, FC } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { Tasks } from './tasks.status-panel';

export type KnownProps = Pick<GridOptions, 'statusBar'>;

interface StatusBarParams {
  isPaginated: boolean;
  loading: boolean;
}
export const withStatusBar = <T extends KnownProps>(
  Component: ComponentType<T>,
): FC<Omit<T, keyof KnownProps> & StatusBarParams> => {
  const Next: FC<Omit<T, 'statusBar'> & StatusBarParams> = ({
    isPaginated,
    loading,
    ...rest
  }) => {
    return (
      <Component
        {...(rest as any)}
        isPaginated={isPaginated}
        loading={loading}
        statusBar={{
          statusPanels: [
            {
              statusPanelFramework: Tasks,
              align: 'left',
              statusPanelParams: { isPaginated, loading },
            },
          ],
        }}
      />
    );
  };

  return setDisplayName(wrapDisplayName(Component, 'WithStatusBar'))(Next);
};
